package com.ijoin.data.api

import com.ijoin.data.model.PlatformFee
import io.ktor.client.call.*
import io.ktor.client.request.*

/**
 * API for public application settings.
 */
class SettingsApi {
    private val client = ApiClient.client
    private val baseUrl = "${ApiClient.getBaseUrl()}/api/settings"

    /**
     * Get platform fee settings.
     */
    suspend fun getPlatformFee(): Result<PlatformFee> = runCatching {
        client.get("$baseUrl/platform-fee").body()
    }

    companion object {
        // Cached instance for performance (simple caching without time expiry)
        private var cachedPlatformFee: PlatformFee? = null

        /**
         * Get platform fee with caching.
         * Cache is valid until clearCache() is called or app restarts.
         */
        suspend fun getPlatformFeeCached(): PlatformFee {
            cachedPlatformFee?.let { return it }

            return try {
                val api = SettingsApi()
                val fee = api.getPlatformFee().getOrNull() ?: PlatformFee.DEFAULT
                cachedPlatformFee = fee
                fee
            } catch (e: Exception) {
                PlatformFee.DEFAULT
            }
        }

        /**
         * Clear cache to force refresh.
         */
        fun clearCache() {
            cachedPlatformFee = null
        }
    }
}
